import isEmpty from 'lodash/isEmpty';
import { bool, number, object, string } from 'prop-types';
import React, { useEffect } from 'react';
import ArticlesList from 'sly/resourceCenter/components/ArticlesList';
import { usePrefetch } from 'sly/services/api/prefetch';

const ArticlesListByTopic = ({
  limit,
  topic,
  id,
  withRedirectToTopicPage,
  articlesTitle,
  topicBottom,
}) => {
  const [newArticleBottomList, setNewArticleBottomList] = React.useState([]);
  const { firstArticle, secondArticle, thirdArticle } = topicBottom || {};
  const filteredId = [
    firstArticle?.id,
    secondArticle?.id,
    thirdArticle?.id,
  ].filter((el) => el);

  const { requestInfo } = usePrefetch('getArticle', {
    'filters[mainTopic][slug][$eq]': topic,
    'pagination[pageSize]': limit,
    ...(!withRedirectToTopicPage && { 'filter[id][$neq]': id }),
    populate: '*',
  });

  const filters = {};
  filteredId.forEach((id, index) => {
    filters['filters[id][$in][' + index + ']'] = id;
  });
  const articlesByUser = usePrefetch(
    'getArticle',
    {
      ...filters,
      'pagination[pageSize]': limit,
      ...(!withRedirectToTopicPage && { 'filter[id][$neq]': id }),
      populate: '*',
    },
    { shouldBail: filteredId.length === 0 }
  );

  useEffect(() => {
    if (!topicBottom) {
      setNewArticleBottomList(requestInfo?.result?.data);
    }
  }, [requestInfo?.result?.data, topicBottom]);

  useEffect(() => {
    if (topicBottom) {
      if (!articlesByUser?.requestInfo?.hasFinished) {
        return;
      }
      if (!articlesByUser?.requestInfo?.result?.data) {
        return;
      }
      const processedArray = [
        ...(articlesByUser?.requestInfo?.result?.data || []),
        ...(requestInfo?.result?.data || []),
      ]
        .filter((el) => el !== null && !isEmpty(el))
        .filter((_el, index) => index + 1 <= limit);
      setNewArticleBottomList(processedArray);
    }
  }, [
    topicBottom,
    articlesByUser.hasFinished,
    requestInfo?.result?.data,
    articlesByUser.requestInfo?.result?.data,
    limit,
    articlesByUser.requestInfo.hasFinished,
  ]);

  if (
    (requestInfo.hasFinished && !requestInfo?.result?.data?.length) ||
    !requestInfo.hasFinished
  )
    return null;

  return (
    <ArticlesList
      {...{
        topic,
        withRedirectToTopicPage,
        articlesTitle,
        articles: newArticleBottomList,
      }}
    />
  );
};

ArticlesListByTopic.propTypes = {
  limit: number,
  topic: string,
  id: number,
  withRedirectToTopicPage: bool,
  articlesTitle: string,
  topicBottom: object,
};

export default ArticlesListByTopic;
